/* מצב האפליקציה: הנתונים מ-Supabase וההגדרות.
   מקור אחד שכל מודולי החישוב קוראים ממנו. כל שינוי בנתונים עובר דרך touch(),
   שמנקה את המטמון של החישובים ומודיע לממשק לצייר מחדש. */

export const S = {
  tx: [],        // transactions
  rec: [],       // recurring
  commits: [],   // commitments (תשלומים עתידיים)
  budgets: [],   // budget_goals (יעדי תקציב לקטגוריה)
  savings: [],   // savings_goals
  cats: [],      // categories (מותאמות)
  members: [],   // family_members
  set: {},       // הגדרות, ראו SETTINGS
  ver: 0,        // כל שינוי (גם בממשק)
  dataVer: 0,    // שינוי בנתונים בלבד
};

/* ── הגדרות שנשמרות בטבלת settings (key/value) ── */
const json = (def) => ({
  parse: (v) => {
    try { return JSON.parse(v) ?? def(); } catch { return def(); }
  },
  ser: (v) => JSON.stringify(v),
  def,
});
const num = (def) => ({ parse: (v) => parseFloat(v) || 0, ser: String, def: () => def });
const str = { parse: (v) => v || '', ser: (v) => v || '', def: () => '' };

export const SETTINGS = {
  month_start: { field: 'monthStart', parse: (v) => parseInt(v, 10) || 1, ser: String, def: () => 1 },
  bal_amount: { field: 'balAmount', ...num(0) },
  bal_date: { field: 'balDate', ...str },
  bal_eod: { field: 'balEod', parse: (v) => !!v && v !== '0', ser: (v) => (v ? '1' : ''), def: () => false },
  od_limit: { field: 'odLimit', ...num(0) },
  buf_target: { field: 'bufTarget', ...num(0) },
  exit_target: { field: 'exitTarget', ...str },
  exit_stage: { field: 'exitStage', ...str },
  exit_end: { field: 'exitEnd', ...json(() => ({})) },
  rec_match: {
    field: 'recMatch',
    ...json(() => ({ alias: {}, skip: {}, link: {} })),
    parse: (v) => {
      try {
        const r = JSON.parse(v) || {};
        return { alias: r.alias || {}, skip: r.skip || {}, link: r.link || {} };
      } catch {
        return { alias: {}, skip: {}, link: {} };
      }
    },
  },
  sav_cfg: { field: 'savCfg', ...json(() => ({})) },
  // "סכום@תקופה": סכום ידני לחיוב הכרטיס של תקופה אחת
  card_manual: {
    field: 'cardManual',
    parse: (v) => {
      const p = String(v || '').split('@');
      return { amount: parseFloat(p[0]) || 0, key: p[1] || '' };
    },
    ser: (v) => (v && v.amount > 0 ? v.amount + '@' + (v.key || '') : '0'),
    def: () => ({ amount: 0, key: '' }),
  },
  dup_ok: { field: 'dupOk', ...json(() => []) },
  rev_ok: { field: 'revOk', ...json(() => []) },
  fix_card_settle_v2: { field: 'fixCardSettle', ...str },
  // מצב התחזית: '' רגיל, 'strict' מחמיר (כולל הערכה להוצאות שוטפות מהעו"ש בתקופות הבאות ובעודף החודשי)
  fc_mode: { field: 'fcMode', ...str },
};

export function resetSettings() {
  S.set = {};
  for (const k of Object.keys(SETTINGS)) S.set[SETTINGS[k].field] = SETTINGS[k].def();
}
resetSettings();

export function applySettingsRows(rows) {
  (rows || []).forEach((r) => {
    const d = SETTINGS[r.key];
    if (d) S.set[d.field] = d.parse(r.value);
  });
}

/* ── מנויים ומטמון ── */
const listeners = new Set();
let memoCache = new Map();

/** הנתונים השתנו: מנקה מטמון ומצייר מחדש */
export function touch() {
  S.ver++;
  S.dataVer++;
  memoCache = new Map();
  listeners.forEach((f) => f());
}
/** רק הממשק השתנה (תקופה מוצגת, מסך): מצייר מחדש בלי לנקות מטמון */
export function notify() {
  S.ver++;
  listeners.forEach((f) => f());
}
export function subscribe(f) {
  listeners.add(f);
  return () => listeners.delete(f);
}

/** חישוב שנשמר עד השינוי הבא בנתונים (או עד שהיום מתחלף) */
export function memo(key, fn) {
  const k = key + '|' + new Date().toDateString();
  if (memoCache.has(k)) return memoCache.get(k);
  const v = fn();
  memoCache.set(k, v);
  return v;
}
